import { PassengerCountInitialValuesType } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-panel.types";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";

export const usePassengerCount = ({
  initialValues,
  searchType
}: {
  initialValues?: PassengerCountInitialValuesType;
  searchType?: "city" | "villa" | "category" | "home";
}) => {
  const router = useRouter();
  const [temporaryPassengerCount, setTemporaryPassengerCount] = useState<{
    adult: number;
    child: number;
    room: number;
  }>({
    adult: initialValues?.adult || 0,
    child: initialValues?.child || 0,
    room: initialValues?.room || 1
  });
  const [passengerCount, setPassengerCount] = useState(temporaryPassengerCount);

  const { adult, child, room } = temporaryPassengerCount;

  const roomSpace = 15;
  const total = (adult || 1) + child;
  const remain = roomSpace * room - total;
  const remainNotAdult = Math.min(remain, (adult || 1) * 12 - child);

  const adultMax = (adult || 1) + remain;
  const adultMin = Math.max(Math.ceil(child / 12), 1);
  const childMax = child + remainNotAdult;

  const onSubmitPassengerCount = useCallback(() => {
    setTemporaryPassengerCount((state) => {
      setPassengerCount(state);
      return state;
    });
  }, []);

  const onChangeAdult = useCallback((value: number) => {
    setTemporaryPassengerCount((state) => ({
      ...state,
      adult: value
    }));
  }, []);

  const list =
    searchType === "home"
      ? [
          {
            increaseDisabled: (adult || 1) >= adultMax,
            decreaseDisabled: (adult || 1) <= adultMin,
            title: "تعداد نفرات",
            subtitle: "",
            value: adult,
            onChange: onChangeAdult
          }
        ]
      : [
          {
            increaseDisabled: (adult || 1) >= adultMax,
            decreaseDisabled: (adult || 1) <= adultMin,
            title: "تعداد مسافر",
            value: adult,
            onChange: onChangeAdult
          }
        ];

  return {
    passengerCountTitle: "مسافر",
    passengerCountResult:
      passengerCount.adult + passengerCount.child === 0
        ? "تعداد مسافر"
        : `${numberConvert(passengerCount.adult + passengerCount.child, {
            locale: router.locale
          })} نفر`,
    passengerCountList: list,
    passengerCount,
    onSubmitPassengerCount,
    passengerCountValidation: {
      isPassengerDisabled: (adult || 1) >= adultMax,
      isChildrenDisabled: child >= childMax,
      isSubmitDisabled: !(room * roomSpace >= total)
    }
  };
};
